//#region ------------ function shorthand -------------------------
var getByID = (element)=>{return document.getElementById(element)}
var getByClass = (element)=>{return document.querySelector('.'+element)}
var getByClassAll = (element)=>{return document.querySelectorAll('.'+element)}
//#endregion ----------------------
// var typingTimer;              
// var doneTypingInterval = 0;
// closedIntro = ()=>{
//   if(getByClass('overlay-intro')){
//     getByClass('overlay-intro').classList.add('closed');
//     clearTimeout(typingTimer);
//     doneTypingInterval = 1000;
//     typingTimer = setTimeout(()=>{
//       getByClass('overlay-intro').classList.add('d-none');
//     }, doneTypingInterval);
//     document.body.style.overflow = 'auto';
//     getByClass('overlay-intro').setAttribute('status','closed');
//     getByClass('overlay-intro').setAttribute('date-closed',dateNow);
//     sessionStorage.setItem("intro-status", "closed");
//   }
// }
document.onreadystatechange = () => {
  if(document.readyState === 'complete'){
      // let introStatus = sessionStorage.getItem("intro-status");
      // if(introStatus == "closed"){
      //   closedIntro()
      // }else{
      //   if (getByClass('overlay-intro')) {
      //     getByClass('overlay-intro').classList.remove('closed');
      //   }
      // }

      if(getCookie("cookieDomain") !== window.location.origin && getCookie("cookieAccept") !== "accepted"){
        getByClass('cookies-consent-popup').classList.remove('d-none');
      }
  }
}


//============================================================ cookies ================================================//
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
acceptCookies=()=>{
  const cookiesPopup = getByClass('cookies-consent-popup');
  cookiesPopup.style.display = 'none';
  setCookie("cookieDomain",window.location.origin, 365)
  setCookie("cookieAccept", "accepted", 365)
  setCookie("dateCookieAccept", dateNow+" "+timeNow, 365)
  fetch('https://api.ipify.org/?format=json')
  .then(result=>result.json())
  .then(data=>setCookie("CookieIPAddress",data.ip, 365))
}

//============================================================== totop button =============================================//
var toTop = document.querySelector('.toTop-btn');
var navbarBanner = document.querySelector('.navbar-banner');
var menuHeader = document.querySelector('.menu-header');
var contentHeaderBlock = document.querySelector('.content-header-block');
let scrollHeight = navbarBanner?navbarBanner.offsetTop:0;
// console.log(menuHeader.offsetTop);
window.addEventListener('scroll', ()=>{
  if (navbarBanner) {
    if(window.pageYOffset >= scrollHeight){
        toTop.style.display = 'flex';
        navbarBanner.classList.add('scrollDown')

    }else{
      toTop.style.display = 'none';        
      navbarBanner.classList.remove('scrollDown')
    }
  }
  if (!navbarBanner && menuHeader) {
    if(window.pageYOffset >= contentHeaderBlock.offsetTop){
        toTop.style.display = 'flex';
        menuHeader.classList.add('scrollDown')

    }else{
      toTop.style.display = 'none';        
      menuHeader.classList.remove('scrollDown')
    }
  }
});
function scrolldiv(){window.scrollTo(0, 0);}
if (toTop) {
  toTop.addEventListener('click',scrolldiv);
}

var dateTime = new Date();
var dateNow = dateTime.getDate()+'-'+dateTime.getMonth()+'-'+dateTime.getFullYear();
var timeNow = dateTime.getHours()+':'+dateTime.getMinutes();

//=============================================================== set text size =======================================================//
var MainHTML = document.getElementsByTagName("html");
var settingText  = getByClassAll("setting-text-select");
var settingTextSelected  = getByClass("setting-text-selected");
if(localStorage.sizeText && localStorage.sizeText == ""){
  MainHTML[0].classList.add('fs-normal');
  if(settingTextSelected){
    settingTextSelected.innerHTML = MainHTML[0].getAttribute('lang') == "" || MainHTML[0].getAttribute('lang') == "th"? "อักษรขนาดปกติ":"Normal font size";
  }
}else{
  if(localStorage.sizeText == "small"){
    MainHTML[0].classList.add('fs-small');
    if(settingTextSelected){
      settingTextSelected.innerHTML = MainHTML[0].getAttribute('lang') == "" || MainHTML[0].getAttribute('lang') == "th"? "อักษรขนาดเล็ก":"Small font size";
    }
  }
  else if(localStorage.sizeText == "normal"){
    MainHTML[0].classList.add('fs-normal');
    if(settingTextSelected){
      settingTextSelected.innerHTML = MainHTML[0].getAttribute('lang') == "" || MainHTML[0].getAttribute('lang') == "th"? "อักษรขนาดปกติ":"Normal font size";
    }
  }
  else if(localStorage.sizeText == "large"){
    MainHTML[0].classList.add('fs-large');
    if(settingTextSelected){
      settingTextSelected.innerHTML = MainHTML[0].getAttribute('lang') == "" || MainHTML[0].getAttribute('lang') == "th"? "อักษรขนาดใหญ่":"Large font size";
    }
  }
}

if(settingText){
  settingText.forEach((settingText)=>{
    settingText.addEventListener('click',()=>{
      const sizeValue = settingText.getAttribute('select-value');    
      location.reload()
      if(sizeValue == "small"){
        localStorage.sizeText = "small";
      }
      else if(sizeValue == "normal"){
        localStorage.sizeText = "normal";
      }
      else if(sizeValue == "large"){
        localStorage.sizeText = "large";
      }
    })
})
}

//=============================================================== set theme web =======================================================//
var body = document.getElementsByTagName('body')[0];
var themeSelect = getByClassAll('theme');
if(localStorage.themeWeb && localStorage.themeWeb == ""){
  body.setAttribute('class','')
  themeSelect.forEach((ts)=>{
    if(ts.getAttribute('theme-name') == localStorage.themeWeb){
      ts.classList.add('active');
      ts.setAttribute('status','active');
    }
  })

}else{
  if(!localStorage.themeWeb){
    body.setAttribute('class','')
  }else{
    if(localStorage.themeWeb !== "normal"){
      body.classList.add(localStorage.themeWeb);
    }
  }
  if(themeSelect){
    themeSelect.forEach((ts)=>{
      if(ts.getAttribute('theme-name') == localStorage.themeWeb){
        ts.classList.add('active');
        ts.setAttribute('status','active');
      }
    })
  }
}
if(themeSelect){
  themeSelect.forEach((theme)=>{    
    
    theme.addEventListener('click',()=>{
      themeSelect.forEach((ts)=>{
        var status = ts.getAttribute('status');
        if(status == "active"){
          ts.classList.remove('active')
          ts.setAttribute('status','');
        }
      })
      theme.classList.add('active')
      theme.setAttribute('status','active');
      localStorage.themeWeb = theme.getAttribute('theme-name');
      location.reload()
    })
  });
}

//========================================= Link Href ====================================================//

hrefLink=(link,targetLink="")=>{
  if(targetLink=="blank"){
    if (link !== "") {
      window.open(link,'_blank');
    }
  }else if(targetLink=="popup"){
    let dataPopup = event.target.getAttribute('data-popup');
    if (link !== "") {
      window.open(link,'popup',dataPopup);
    }
  }else{
    if (link !== "") {
      window.open(link,'_self');
    }
  }
}

//========================================= auto focus ====================================================//

INPUTautofocus=()=>{
  let idEle = getByID(event.target.getAttribute('data-focus'));
  idEle.value=" ";
  idEle.focus();
  idEle.value="";
}

//========================================= download APP ====================================================//
getOS=()=> {
    var userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;
  
    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }
  
    return os;
  }

  appLink=(type)=>{
      const os = getOS();

      if(os == 'Mac OS' || os == 'iOS'){
        if(type == 'main'){
            window.open('https://apps.apple.com/th/app/mrta-thailand/id1496902027','_blank');
        }
        else if(type == 'parking'){
            window.open('https://apps.apple.com/th/app/mrta-parking/id1579312949','_blank');
        }
      }
      else{
        if(type == 'main'){
            window.open('https://play.google.com/store/apps/details?id=com.mrta.mrta','_blank');
        }
        else if(type == 'parking'){
            window.open('https://play.google.com/store/apps/details?id=com.mrta.mrtaparking','_blank');
        }
      }
  }



//========================================= loading animation ====================================================//

const observer_1 = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    const announce = entry.target.querySelector('.announce-box');
    const adLink = entry.target.querySelectorAll('.text-linked');
    // const announceNews = entry.target.querySelector('.announce-news');

    if (entry.isIntersecting) {
      announce.classList.add('observer');
      // announceNews.classList.add('observer');
      removeSkeleton = setTimeout(()=>{    
        adLink.forEach((adLink)=>{
        adLink.classList.remove('loading-skeleton');})
      }, 1500);
      // clearTimeout(removeSkeleton);
	    return; // if we added the class, exit the function
    }

    // We're not intersecting, so remove the class!
    announce.classList.remove('observer');
    // announceNews.classList.remove('observer');
  });
  // entries.forEach(entry => {
  //   if (entry.isIntersecting) {
  //     entry.target.classList.add('observer');
  //     entry.target.classList.remove('loading-skeleton');
  //   }
  // });
});

if(document.querySelector('.main-box')){
  observer_1.observe(document.querySelector('.main-box'));
}
// observer.observe(document.querySelector('.text-linked'));


const observer_2 = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('observer');
      removeSkeleton = setTimeout(()=>{    
        getByClassAll('table-date').forEach((table)=>{
          table.classList.remove('loading-skeleton');})
      }, 1500);
    }
    // entry.target.classList.remove('observer');
  });
});
if(document.querySelector('.announce-news')){
  observer_2.observe(document.querySelector('.announce-news'));
}
// observer.observe(document.querySelector('.text-linked'));

//-------------------------------------------------- img click ----------------------------//
boxDescription = getByClassAll('box-description');
if (boxDescription) {
  boxDescription.forEach(boxDescription => {    
    imgContent = boxDescription.querySelectorAll('img');
    imgContent.forEach(imgContent => {      
      let alt = imgContent.getAttribute('alt');
      parentTag = imgContent.parentNode.tagName;
      console.log(parentTag)
      if (parentTag != 'A') {
        imgContent.setAttribute('role','button');
        srcUrl = imgContent.getAttribute('src');
        imgContent.setAttribute('onclick',"hrefLink('"+srcUrl+"','blank')");
      }
      if (alt !== '') {
        imgContent.setAttribute('alt','description image')
        imgContent.setAttribute('aria-label','description-image')
        
      }
    });
  });
}
subFaqContent = getByClassAll('sub-faq-content');
if (subFaqContent) {
  subFaqContent.forEach(subFaqContent => {
    imgContent = subFaqContent.querySelectorAll('img');
    imgContent.forEach(imgContent => {
      let alt = imgContent.getAttribute('alt');
      if (alt !== '') {
        imgContent.setAttribute('alt','faq-image')
      }
    })
  })
}